import { formatBrl } from '@estac1/shared';
import { PageHeader } from '@estac1/ui';
import { CapacityUpsellCard } from './clients/capacity-upsell-card.js';
import { ClientDialogs } from './clients/client-dialogs.js';
import { ClientFilters } from './clients/client-filters.js';
import { ClientList } from './clients/client-list.js';
import { KpiCard } from './clients/kpi-card.js';
import { useClientsScreen } from './clients/use-clients.js';

export const ClientsScreen = () => {
  const s = useClientsScreen();

  return (
    <div className="space-y-6">
      <PageHeader title="Clientes" description="Donos cadastrados e seus estacionamentos." />

      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        <KpiCard
          label="Ativos"
          value={String(s.kpis.active)}
          hint={s.kpis.active === 0 ? '—' : `${s.kpis.active} estacionamentos pagantes`}
        />
        <KpiCard
          label="Em teste"
          value={String(s.kpis.trial)}
          hint={s.kpis.trial === 0 ? '—' : 'aguardando virar pagantes'}
        />
        <KpiCard
          label="Atrasados"
          value={String(s.kpis.pastDue)}
          hint={s.kpis.pastDue === 0 ? '—' : 'pagamento pendente'}
        />
        <KpiCard
          label="MRR estimado"
          value={formatBrl(s.kpis.mrrCents)}
          hint={s.pricing.data ? 'com base na tabela atual' : 'carregando tabela…'}
        />
      </div>

      <CapacityUpsellCard />

      <ClientFilters
        search={s.search}
        statusFilter={s.statusFilter}
        onSearch={s.setSearch}
        onStatusFilter={s.setStatusFilter}
      />

      <ClientList
        clientsLoading={s.clients.isLoading}
        clientsError={s.clients.isError}
        filtered={s.filtered}
        search={s.search}
        statusFilter={s.statusFilter}
        pricing={s.pricing.data}
        onExtend={(l) => s.setExtending({ lotId: l.id, lotName: l.name })}
        onArchive={(l) => {
          s.setPendingArchive(l);
          s.archiveConfirm.confirm(() => s.archive.mutateAsync(l.id));
        }}
        onUnarchive={(l) => {
          s.setPendingUnarchive(l);
          s.unarchiveConfirm.confirm(() => s.unarchive.mutateAsync(l.id));
        }}
        onResetCheckout={(l) => {
          s.setPendingResetCheckout(l);
          s.resetCheckoutConfirm.confirm(() => s.resetCheckout.mutateAsync(l.id));
        }}
        onToggleModule={(l, key, enabled) => {
          s.setPendingModuleToggle({ lot: l, key, enabled });
          s.moduleToggleConfirm.confirm(() =>
            s.toggleModule.mutateAsync({ lotId: l.id, key, enabled }),
          );
        }}
        unarchive={s.unarchive}
        toggleModule={s.toggleModule}
        resetCheckout={s.resetCheckout}
      />

      <ClientDialogs
        extending={s.extending}
        setExtending={s.setExtending}
        extraDays={s.extraDays}
        setExtraDays={s.setExtraDays}
        extendTrial={s.extendTrial}
        archiveConfirm={s.archiveConfirm}
        unarchiveConfirm={s.unarchiveConfirm}
        moduleToggleConfirm={s.moduleToggleConfirm}
        resetCheckoutConfirm={s.resetCheckoutConfirm}
        pendingArchive={s.pendingArchive}
        pendingUnarchive={s.pendingUnarchive}
        pendingResetCheckout={s.pendingResetCheckout}
        pendingModuleToggle={s.pendingModuleToggle}
        archive={s.archive}
        unarchive={s.unarchive}
        resetCheckout={s.resetCheckout}
        toggleModule={s.toggleModule}
      />
    </div>
  );
};
